import $ from 'jquery'; 
window.$ = window.jQuery = $;

// ************ Hover Start*************** //

var $cjsType ,$cjsParam , $curEle ,$curEleName, $curParentEle ,$curEleWidth ,$cjs_badge_div ,CjsTxt,$inputTxt;

function cjs_change_text(el,type){
     CjsTxt = 'Description';
     let cjsTop,cjsLeft
    if(type==1){
        el.addClass('cjs-badge-del');
        $cjs_badge_div = '<div class="cjs-badge" ><div class="cjs-badge-del-text">Delete</div> </div>';
         cjsTop = (el.offset().top - 15) <= 0 ? 0 : ((el.offset().top + 5)) ;
         cjsLeft = (el.offset().top ) <= 0 ? el.offset().left + el.width()  : (el.offset().left + el.width() + 30);
       
    }else if(type==2){
        el.addClass('cjs-badge-copy');
        $cjs_badge_div = '<div class="cjs-badge" ><div class="cjs-badge-copy-text">Copy</div></div>';
         cjsTop = (el.offset().top - 15) <= 0 ? 0 : ((el.offset().top + 5)) ;
         cjsLeft = (el.offset().top ) <= 0 ? el.offset().left + el.width()  : (el.offset().left + el.width() + 30);
       
    }else if(type==3){
        el.addClass('cjs-badge-copy-del');
        $cjs_badge_div = '<div class="cjs-badge cjs-badge-copy-del-div " ><div class="cjs-badge-copy-text">Copy</div> <div class="cjs-badge-del-text">Delete</div> </div>';
         cjsTop = (el.offset().top - 15) <= 0 ? 0 : ((el.offset().top + 5)) ;
         cjsLeft = (el.offset().top ) <= 0 ? el.offset().left + el.width()  : (el.offset().left + el.width() - 15);
       
    }else{
         $cjs_badge_div = '<div class="cjs-badge"><div class="cjs-badge-name"></div> </div>';
         cjsTop = (el.offset().top - 15) <= 0 ? 0 : ((el.offset().top - 20)) ;
         cjsLeft = (el.offset().top ) <= 0 ? el.offset().left + 0 : el.offset().left - 5;
       
    }
    $curEle = el;
    
    
    $("body .cjs-badge:first").remove();
    $('body').prepend($cjs_badge_div);
    $('.cjs-badge-name').text(CjsTxt);
    $('.cjs-badge').show();
    $('.cjs-badge').css({"top":cjsTop+"px", "left":cjsLeft+"px"});
}


function cjs_text_mouse_enter(e, ele,type=0){
    $curEleHover = e.target;
    $curEleNameHover = $curEleHover.nodeName.toLowerCase();
    if( $curEleNameHover === 'a' ) {
        $hrefVal = e.target.getAttribute('href');
        if($hrefVal.charAt(0)!='#'){
            ele.attr('href', '#'+$hrefVal);
        }
    }
    if($('body').hasClass('cjs-selected-item')){

    }else{
        if(type!=0){
            cjs_change_text(ele,type);
        }else{
            if(ele.hasClass('cjs-change-text')){
                cjs_change_text(ele,type);
            }
        }
        
     }

}


function cjs_text_mouse_leave(e, ele,type=0){

    $curEleHover = e.target;
        $curEleNameHover = $curEleHover.nodeName.toLowerCase();
        if( $curEleNameHover === 'a' ) {
            $hrefVal = e.target.getAttribute('href');
            if($hrefVal.charAt(0)!='#'){
                ele.attr('href',$hrefVal.substr(1));
            }
        }
       if($('body').hasClass('cjs-selected-item')){

        }else{
            if(type==1){
                ele.removeClass('cjs-badge-del'); 
            }else if(type==2){
                ele.removeClass('cjs-badge-copy'); 
            }else if(type==3){
                ele.removeClass('cjs-badge-copy-del'); 
            } 
            $('.cjs-badge').remove();
        }

}
    
$(document).ready(function(){
    /*$saveTemplateHtml = '<div class="cjs-loader"><div class="cjs-loader-item">Loading.....</div></div><div class="cjs-save-template-div"><button class="cjs-save-btn">Save Template</button></div>';

    $("body").prepend($saveTemplateHtml);*/
});            

 $(document).on({
    mouseenter: function (e) {
        cjs_text_mouse_enter(e, $(this));
    },
    mouseleave: function (e) {
       cjs_text_mouse_leave(e, $(this));
    }
}, ".cjs-change-text"); 


$(document).on({
    mouseenter: function (e) {
        cjs_text_mouse_enter(e, $(this),1);
    },
    mouseleave: function (e) {
       cjs_text_mouse_leave(e, $(this),1);
    }
}, ".cjs-change-text-with-del"); 


$(document).on({
    mouseenter: function (e) {
        cjs_text_mouse_enter(e, $(this),2);
    },
    mouseleave: function (e) {
       cjs_text_mouse_leave(e, $(this),2);
    }
}, ".cjs-change-text-with-copy"); 


$(document).on({
    mouseenter: function (e) {
        cjs_text_mouse_enter(e, $(this),3);
    },
    mouseleave: function (e) {
       cjs_text_mouse_leave(e, $(this),3);
    }
}, ".cjs-change-text-copy-del"); 
// ************ Hover Ends *************** //




function cjs_delete(ele){
    ele.remove();

}
function cjs_copy(ele)
{
    //alert("dunction called");
    var itm = document.getElementById("rd");
    var cln = itm.cloneNode(true);
    document.getElementById("pd").appendChild(cln);
    /*
    console.log(ele.index());
    if(ele.hasClass('cjs-change-text-copy-del')){
        ele.clone().insertAfter(ele);
     }else{
        ele.addClass('cjs-change-text-copy-del').clone().insertAfter(ele);
        ele.removeClass('cjs-change-text-copy-del');

    }*/
    
}

$(document).on('click', '.cjs-badge-del', function(e) {
    cjs_delete($curEle);
});

/*$(document).on('click', '.cjs-badge-copy', function(e) 
{
    alert("yes");
    cjs_copy($curEle);
});*/
// cjs-change-text
$(document).on('click', '.cjs-change-text', function(e) {
    e.stopPropagation();
    if($('body').hasClass('cjs-selected-item')){
        $($curEle).text($('.cjs-selected').val()).show();
        $('body').removeClass('cjs-selected-item');
        $('.cjs-badge').remove();
        $('.cjs-selected').remove();
    
    }
    $cjsType = e.target.getAttribute('cjs-badge-type');
    $cjsParam = e.target.getAttribute('cjs-param');
    $curEle = e.target;
    $curEleName = $curEle.nodeName.toLowerCase();
    $curParentEle =  $curEle.parentElement;
    $curEleWidth = $curEle.offsetWidth;
    $('body').addClass('cjs-selected-item');
    CjsTxt = 'Text';
    
    if( $curEleName === 'a' ) {
        e.stopImmediatePropagation();
        e.preventDefault();
    }
    if( $curEleName === 'input' ) {
        // alert('input');
    }else if( $curEleName === 'img' ) {
        // alert('input');
    }else{
        
        $inputTxt = '<input type="text" class="cjs-selected" style="width:'+$curEleWidth+'px" value="'+$($curEle).text()+'"/>';
        $cjs_badge_div = '<div class="cjs-badge" data-badge="" style="width:'+$curEleWidth+'px"><div class="cjs-badge-save"><span class="cjs-save-item">Save</span><span class="cjs-cross">Cancel</span></div></div><div class="cjs-badge" ><div class="cjs-badge-copy-text cjs-badge-copy">Copy</div></div>';
        if($(this).find('.cjs-change-text').length){
            CjsTxt = 'Text';
        }
        let cjsTop, cjsLeft = 0;
        if($(this).offset().top < 30){
             cjsTop = ($(this).offset().top + $(this).height() + 25) ;
             cjsLeft = ($(this).offset().top ) <= 0 ? $(this).offset().left + 0 : $(this).offset().left - 5;
        
        }else{
             cjsTop = ($(this).offset().top - 35) <= 0 ? 0 : (($(this).offset().top - 45)) ;
             cjsLeft = ($(this).offset().top ) <= 0 ? $(this).offset().left + 0 : $(this).offset().left - 5;
        
        }
        $($curEle).hide();
        $($curEle).after($inputTxt);
        $("body .cjs-badge:first").remove();
        $('body').prepend($cjs_badge_div);
        $('.cjs-badge-name').text(CjsTxt);
        $('.cjs-badge').show();
        $('.cjs-badge').css({"top":cjsTop+"px", "left":cjsLeft+"px"});
       

    
    }
   
   
});


// cjs-change-text
$(document).on('click', '.cjs-save-item',function(e) 
{
    let data = $(".cjs-selected").val();
    alert(data);
    if(data == '')
    {
        alert("Please Fill Description Box");
    }
    else
    {
        /*$.ajax(
            {
                url: baseurl + '/premiumvendordescription/'+data,
                type: 'get',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                data: {"_token": "{{ csrf_token() }}","data": data},
                dataType: 'json',
                success: function(response)
                {
                    $($curEle).text($('.cjs-selected').val()).show();
                        $('body').removeClass('cjs-selected-item');
                        $('.cjs-badge').remove();
                        $('.cjs-selected').remove();
                }
            });*/
    }
    
    /*$('.cjs-save-item').remove();
    $('.cjs-cross').remove();  
    $('body').removeClass('cjs-selected-item');*/
    //alert(data);
    /*$.ajax(
    {
        url: baseurl + '/premiumvendordescription',
        type: 'POST',
        headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
        data: {"_token": "{{ csrf_token() }}","data": data},
        dataType: 'json',
        success: function(response)
        {
            
        }
    });*/
    
    /*$($curEle).text($('.cjs-selected').val()).show();
    $('body').removeClass('cjs-selected-item');
    $('.cjs-badge').remove();
    $('.cjs-selected').remove();*/
});

$(document).on('click', '.cjs-cross',function(e) {
    $('body').removeClass('cjs-selected-item')
    $($curEle).show();
    $('.cjs-badge').remove();
    $('.cjs-selected').remove();
});


$(document).on('click', '.cjs-save-btn',function(e) {
    var cjs_params_array = {};
    alert($(".cjs-change-text").length);
    $(".cjs-change-text").each(function() {
        var $cjsParamKey = $(this).attr('cjs-param');
        var $cjsParamVal = $(this).text();
        $cjsParamKey = $(this).attr('cjs-param');
        console.log($cjsParamKey);
        console.log($cjsParamVal);
        
        cjs_params_array[$cjsParamKey] = $cjsParamVal;
        
    });
    if(Object.keys(cjs_params_array).length){
        console.log(JSON.stringify(cjs_params_array));
        console.log(cjs_params_array);
        $.ajax({
            type: 'POST',
            url: "index.php",
            data: JSON.stringify(cjs_params_array),
            beforeSend:function(){
                $('.cjs-loader').show();
            },
            success: function(resultData) { alert("Save Complete") }
      });
    }
    
});


